const HARD_REFRESH_QUERY_PARAM = "_ts";

async function clearAllServiceWorkerCaches() {
    if (typeof window === "undefined" || !("caches" in window)) return;

    const cacheKeys = await caches.keys();
    await Promise.all(cacheKeys.map(cacheKey => caches.delete(cacheKey)));
}

async function unregisterServiceWorkers() {
    if (typeof navigator === "undefined" || !("serviceWorker" in navigator)) return;

    const registrations = await navigator.serviceWorker.getRegistrations();
    await Promise.all(registrations.map(registration => registration.unregister()));
}

export async function forceAppRefresh() {
    await Promise.allSettled([clearAllServiceWorkerCaches(), unregisterServiceWorkers()]);

    const url = new URL(window.location.href);
    url.searchParams.set(HARD_REFRESH_QUERY_PARAM, String(Date.now()));
    window.location.replace(url.toString());
}
